import { render, staticRenderFns } from "./BlockExpansionHeader.vue?vue&type=template&id=6659e175&scoped=true"
import script from "./BlockExpansionHeader.vue?vue&type=script&lang=js"
export * from "./BlockExpansionHeader.vue?vue&type=script&lang=js"
import style0 from "./BlockExpansionHeader.vue?vue&type=style&index=0&id=6659e175&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6659e175",
  null
  
)

export default component.exports